import { useState, useCallback } from 'react';
import { getLocationAndPincodeAction } from '../Onboarding/auth/action';

const useLocationPincode = () => {
  const [allPincodes, setAllPincodes] = useState([]);
  const [allCities, setAllCities] = useState([]);

  const getlocationPincode = useCallback(async (districtId, locationId = null, PincodeId = null) => {
    const { data, error } = await getLocationAndPincodeAction(districtId, { location_id: locationId, pincode_id: PincodeId });
    if (!error) {
      if (locationId) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          }))
        );
      } else if (PincodeId) {
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          }))
        );
      } else {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          }))
        );
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          }))
        );
      }
    }
  }, []);

  return { allPincodes, allCities, getlocationPincode };
};

export default useLocationPincode;
